import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const NetWorthContext = createContext({ map: {}, total: null, reload: () => {}, visible: false });

export function NetWorthProvider({ children }) {
  const { user } = useAuth();
  const [map, setMap] = useState({});
  const [total, setTotal] = useState(null);
  const visible = !!user?.can_vote;
  const reload = useCallback(() => {
    api.get("/networth/total").then(({ data }) => setTotal(data)).catch(() => {});
    if (!visible) { setMap({}); return; }
    api.get("/networth").then(({ data }) => setMap(data)).catch(() => setMap({}));
  }, [visible]);
  useEffect(() => { reload(); }, [reload]);
  return <NetWorthContext.Provider value={{ map, total, reload, visible }}>{children}</NetWorthContext.Provider>;
}

export const useNetWorth = () => useContext(NetWorthContext);

export const formatINR = (n) => (n === null || n === undefined ? "" : Number(n).toLocaleString("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }));
export const tinyINR = (n) => {
  if (!n) return "0";
  if (n >= 1e7) return `${+(n / 1e7).toFixed(1)}Cr`;
  if (n >= 1e5) return `${+(n / 1e5).toFixed(1)}L`;
  if (n >= 1e3) return `${Math.round(n / 1e3)}K`;
  return `${Math.round(n)}`;
};
export const shortINR = (n) => {
  if (n === null || n === undefined) return "";
  if (n >= 1e7) return `₹${+(n / 1e7).toFixed(2)} Cr`;
  if (n >= 1e5) return `₹${+(n / 1e5).toFixed(2)} L`;
  return formatINR(n);
};
